"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readTime = void 0;
function readTime(value) {
    if (!value)
        return [0, 0];
    let [hour, minute] = value.split(':').map((e) => Number(e));
    hour = Number.isNaN(hour) || hour < 0 || hour >= 24 ? 0 : hour;
    minute = Number.isNaN(minute) || minute < 0 || minute >= 60 ? 0 : minute;
    return [hour, minute];
}
exports.readTime = readTime;
//# sourceMappingURL=readTime.js.map